import React from 'react';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import clsx from 'clsx';
import LabelIcon from '@material-ui/icons/Label';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import TodayIcon from '@material-ui/icons/EventAvailableOutlined'
import AssignmentOutlinedIcon from '@material-ui/icons/InsertInvitationOutlined'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import CheckIcon from '@material-ui/icons/Check';
import CmtMediaObject from 'components/@coremat/CmtMediaObject';
import { getTime } from '../../../../components/@jumbo/utils/dateHelper';
import useStyles from './index.style';
import moment from 'moment-timezone'
import {styled } from '@material-ui/styles'
import ReactHtmlParser from 'react-html-parser'
import {isEmpty} from 'lodash'
import IntlMessages from 'util/IntlMessages';
import { useSelector } from "react-redux";

const EventItem = ({ item, goToAttGora }) => {
  const classes = useStyles();
  const locale = useSelector((state) => state.settings.locale.locale);
  const GetFirstPartOfText = (text) => {
    text = text.replace(/<[^>]+>/g, '')
    const length = 40
    let dots = String(text).length > length ? '...' : ''
    return ReactHtmlParser(`<span>${String(text).slice(0, length) + dots}</span>`)
  }
  const getMType = (Mtype)=>{
    switch(Mtype){
      case "Fysiskt":return <span className={classes.etikett} style={{backgroundColor: "#0079BF"}}><IntlMessages id="Option.Meeting.type1"/></span>
      case "Webb":return <span className={classes.etikett} style={{backgroundColor: "#EB5A46"}}><IntlMessages id="Option.Meeting.type2"/></span>
      case "Tele":return <span className={classes.etikett} style={{backgroundColor: "#FF9F1A"}}><IntlMessages id="Option.Meeting.type3"/></span>
      case "Internt":return <span className={classes.etikett} style={{backgroundColor: "#FF9F1A"}}><IntlMessages id="Option.Meeting.type4"/></span>
      default:return ""
    }
  }
  const getM1Type = (Mtype)=>{
    switch(Mtype){
      case "Möte":return <span className={classes.etikett} style={{backgroundColor: "#0079BF"}}><IntlMessages id="Meeting"/></span>
      case "Att göra":return <span className={classes.etikett} style={{backgroundColor: "#EB5A46"}}><IntlMessages id="Label.Todo"/></span>
      default:return <span className={classes.etikett} style={{backgroundColor: "#FF9F1A"}}>{Mtype}</span>
    }
  }
  const getSubTitle = () => {
    let AktiDate = new Date(`${moment(new Date(item.date).toLocaleString("sv-SE")).tz("Europe/Stockholm").format('YYYY-MM-DD')}T${
      moment(new Date(item.date).toLocaleString("sv-SE")).tz("Europe/Stockholm").format("HH:mm")
    }Z`)
    return    <>
    <p className={classes.subTitleRoot}>
      <span >
        <span style={{color:moment(new Date().toLocaleString("sv-SE")).isBefore(item.date) ?"#000":"#ff0000"}}>
          {
            parseInt(item.ismote) === 0?
            `${ moment(AktiDate).format('DD/MM')} ${getTime(AktiDate,locale)}` 
            :
            `${ moment(item.date).format('DD/MM')} ${getTime(item.date,locale)}`            
            }
        </span>
        </span>
      <span style={{margin: '0px 4px'}}>
        |
      </span>
      <IntlMessages id="Table.Customer"/>:
      <span className='text-primary ml-1' color="primary.main" >
        {item.scheduled_with.name}
      </span>
    </p>
    {
        item.Body !== '' &&
        <p className={classes.subTitleRoot}>
          <span>
            {!isEmpty(item.Title) ? item.Title : GetFirstPartOfText(item.Body)}
          </span>
          <span style={{float:"right",}}>
            
          </span>
        </p>
      }
    </>
 };

  return (
    <div
    style={{
      boxShadow: "0 4px 6px rgba(47, 43, 61,.1),0 0 transparent,0 0 transparent",
      borderRadius: "5px",
      background: "white",
      padding: "5px 16px",
      margin: "5px"
    }}
    
    className={clsx(classes.eventItemRoot, { checked: item.isAttended })}>
			<div className='d-flex align-items-center' style={{gap: 16}} onClick={() => goToAttGora(item)}>
        <div color="primary.main">
          <Tooltip classes={{ tooltip: classes.tooltipInfo }}  title={
            <p style={{fontSize: '1.5em'}} dangerouslySetInnerHTML={{ __html:item.Body }}></p>
          } aria-label="info"  placement="bottom-start">
            {parseInt(item.ismote) === 1 ? <TodayIcon color="primary"/> : <CheckCircleOutlineIcon color="primary"/>}
          </Tooltip>
        </div> 
				<div style={{flex:1}}>
					<div className={classes.titleRoot} style={{display: 'flex', justifyContent: 'space-between'}}>
						<p style={{
						fontSize:16,
						width: item.event_name === 'Möte'?222:250,
						overflow:"hidden", 
						whiteSpace:"nowrap", 
						textOverflow: "ellipsis"
						}}>{isEmpty(item.Title)?item.event_name:item.Title}</p>

						<span style={{margin:"auto 5px",fontSize:11}}>
							{getMType(item.Mtype)}
							{getM1Type(item.event_name)}
						</span>
					</div>
					{getSubTitle()}	
				</div>
			</div>

      
    </div>
  );
};

export default EventItem;
